import React from 'react';
import { Zap, MailCheck, RefreshCw, TrendingUp, MessageCircle, Repeat, ArrowUpRight } from 'lucide-react';
import { services } from '../mock';
import { Link } from 'react-router-dom';

const iconMap = {
  zap: Zap,
  'mail-check': MailCheck,
  'refresh-cw': RefreshCw,
  'trending-up': TrendingUp,
  'message-circle': MessageCircle,
  repeat: Repeat,
};

const ServicesGrid = () => {
  return (
    <section className="container-x section" data-testid="services-grid">
      <div className="grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7">
          <p className="text-xs uppercase tracking-[0.25em] text-[var(--gh-orange)] font-semibold">
            What we ship
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold mt-3 leading-[1.05] text-ink">
            Powerful solutions, tailored for{' '}
            <span className="font-serif italic text-[var(--gh-orange)]">excellence</span>{' '}
            every time.
          </h2>
        </div>
        <p className="lg:col-span-5 text-base md:text-lg text-muted-warm">
          Six engagements that compound. Pick one that solves your bottleneck — or
          combine them inside a monthly retainer.
        </p>
      </div>

      <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {services.map((s, i) => {
          const Icon = iconMap[s.icon] || Zap;
          const highlight = i === 1; // middle of top row
          return (
            <Link
              to="/services"
              key={s.id}
              data-testid={`service-card-${s.id}`}
              className={`group relative rounded-[1.75rem] p-7 md:p-8 flex flex-col transition-all border ${
                highlight
                  ? 'bg-[var(--gh-orange)] text-[var(--gh-cream)] border-transparent shadow-[0_25px_50px_-25px_rgba(234,88,12,0.55)]'
                  : 'bg-cream border-line hover:-translate-y-1 hover:border-ink'
              }`}
            >
              <div className="flex items-center justify-between">
                <span
                  className={`w-12 h-12 rounded-2xl flex items-center justify-center ${
                    highlight ? 'bg-white/20 text-white' : 'bg-[var(--gh-orange-soft)] text-[var(--gh-orange)]'
                  }`}
                >
                  <Icon className="w-5 h-5" />
                </span>
                <span
                  className={`text-[11px] uppercase tracking-widest font-semibold ${
                    highlight ? 'text-white/70' : 'text-muted-warm'
                  }`}
                >
                  0{s.id}
                </span>
              </div>
              <h3
                className={`font-display text-xl md:text-2xl font-bold mt-7 leading-tight ${
                  highlight ? 'text-white' : 'text-ink'
                }`}
              >
                {s.title}
              </h3>
              <p
                className={`mt-3 text-sm leading-relaxed ${
                  highlight ? 'text-white/85' : 'text-muted-warm'
                }`}
              >
                {s.description}
              </p>
              <p
                className={`mt-4 text-xs uppercase tracking-widest font-semibold ${
                  highlight ? 'text-white/70' : 'text-[var(--gh-orange)]'
                }`}
              >
                {s.benefit}
              </p>
              <span
                className={`mt-7 inline-flex items-center gap-2 text-sm font-semibold ${
                  highlight ? 'text-white' : 'text-ink group-hover:text-[var(--gh-orange)]'
                }`}
              >
                Learn more <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default ServicesGrid;
